import { ApolloClient, ApolloLink, HttpLink, split } from '@apollo/client'
import { getMainDefinition } from '@apollo/client/utilities'

import { authLink } from './auth-link'
import { cache } from './cache'
import { checkVersionLink } from './check-version-link'
import { websocketLink } from './websocket-link'

const httpLink = new HttpLink({
  uri: '/graphql',
})

const splitLink = split(
  (d) => {
    const definition = getMainDefinition(d.query)
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription'
  },
  websocketLink,
  ApolloLink.from([checkVersionLink, httpLink])
)

export const apolloClient = new ApolloClient({
  link: ApolloLink.from([authLink, splitLink]),
  cache,
  connectToDevTools: /localhost/.test(location.hostname),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-first',
      nextFetchPolicy: 'cache-first',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'cache-first',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
})
